export default "__VITE_ASSET__aDooc3st__"